import React from 'react';
import {
  AreaChart, Area, BarChart, Bar, LineChart, Line, ComposedChart,
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  Cell, ReferenceLine, ReferenceArea, Legend
} from "recharts";
import {
  RouteIcon, TrendingUp, Users, Activity, Crosshair, Sparkles,
  Trophy, ClipboardList, NotebookPen, Plus, Pencil, Trash2,
  ChevronDown, ChevronUp, Search, ArrowUpRight, ArrowDownRight,
  Download, Calendar, Clock, CheckCircle2, XCircle, AlertTriangle,
  Info, Zap, Brain, BarChart3, X, UserCheck, Building2,
  HeartHandshake, CalendarDays, CalendarCheck, Stethoscope,
  FlaskConical, Headphones, Receipt, Smartphone, Globe,
  HeartPulse, MessageSquare, ShoppingCart,
  CircleAlert, Lightbulb, TrendingDown, ScanSearch, Filter,
  Bell, Send, PanelLeftClose, PanelLeft, Archive, Link as LinkIcon, ExternalLink,
  History, Heart, MessageCircle, Share2, Upload, MapPin,
  ThumbsUp, ThumbsDown, EyeOff, Eye, Phone, Mail
} from "lucide-react";
import * as S from './_shared';
export default function BenchmarkingView({ ctx }) {
  const {
    ACOES_INIT,
    AcaoCard,
    AcaoDetalhe,
    AcaoModal,
    C,
    CES_COLS,
    CES_ETAPAS_NAMES,
    CES_TREND,
    CIDADES_COBERTURA,
    COOP_PLANOS_MOCK,
    CSAT_COLS,
    CSAT_ETAPAS_NAMES,
    CSAT_TREND,
    Card,
    DRIVERS_CANONICOS,
    DRIVER_TO_PILLAR,
    DistBar,
    ESCALA,
    ETAPA_DRIVER_AFFINITY,
    ETAPA_HIST,
    EtCard,
    EvaChat,
    EvaChatHistory,
    EvaInsights,
    F,
    HIST_ACOES_POR_ETAPA,
    JCFG,
    JICONS,
    LOGO,
    MESES_HIST,
    META_NPS,
    MUDANCAS_DESDE_ULTIMA_VISITA,
    MiniSparkline,
    NPSAnchor,
    PC,
    PDFExportModal,
    PER,
    PER_DEFAULT_LABELS,
    PER_OPTIONS,
    PILLAR_COLORS,
    PeriodPill,
    PeriodPillBig,
    SC,
    SHORT,
    SUCESSO_BADGES,
    SUCESSO_LEVELS,
    SYS_NPS,
    Section,
    TREND_BY_AGRUP,
    TT,
    Tag,
    ULTIMA_VISITA,
    UNIMED,
    VERBATINS_POR_ETAPA,
    Z_CX,
    Zonas,
    _META_CES_TR,
    _META_CSAT_TR,
    _META_NPS_TR,
    _SYS_CES_TR,
    _SYS_CSAT_TR,
    _SYS_NPS_TR,
    diasRest,
    etSt,
    exportPDF,
    fmtDt,
    getDriverInfo,
    getDriversForEtapa,
    getPilarOf,
    getSucessoStats,
    moe,
    pctChk,
    safeGanhoPp,
    tempoRelativo,
    todayStr
  } = S;
  const {
    DATA,
    SAUDACAO_EVA,
    acaoSel,
    acoes,
    adicionarComentario,
    agrupT,
    atualizarMensagensChatEva,
    bulkApplyEtapas,
    bulkApplyGerais,
    bulkOpen,
    bulkPct,
    busca,
    cidadesAtivas,
    compartilharPlano,
    concluirWizard,
    coopBusca,
    coopComentariosAbertos,
    coopCurtidas,
    coopDriverFilter,
    coopEtapaFilter,
    coopNovoComentario,
    coopPlanos,
    d,
    db,
    dd,
    de,
    delAcao,
    desocultarNotif,
    dj,
    driverSortMode,
    ds,
    editandoMeta,
    editandoMetaEt,
    etapaDriversFilter,
    etapaHistSel,
    etapaSel,
    evaChatAtivoId,
    evaChats,
    excluirChatEva,
    filtroCidadeAberto,
    filtroResp,
    filtroSt,
    gamificacaoOn,
    hiddenLines,
    historicoEvaVisivel,
    jorGraf,
    marcarComoLida,
    marcarTodasLidas,
    metas,
    metasCardOpen,
    metasEtapas,
    modal,
    mostrarOcultos,
    naoLidas,
    nenhumaCidade,
    notifModalFiltro,
    notifModalOpen,
    notifOpen,
    notifs,
    notifsOcultas,
    notifsVisiveis,
    novoChatEva,
    ocultarNotif,
    openPublishWizard,
    pB,
    pD,
    pE,
    pJ,
    pS,
    per,
    periodoCustom,
    periodoG,
    respDropOpen,
    segHistMode,
    segIndicador,
    selecionarChatEva,
    setAcaoSel,
    setAcoes,
    setAgrupT,
    setBulkApplyEtapas,
    setBulkApplyGerais,
    setBulkOpen,
    setBulkPct,
    setBusca,
    setCidadesAtivas,
    setConcluirWizard,
    setCoopBusca,
    setCoopComentariosAbertos,
    setCoopCurtidas,
    setCoopDriverFilter,
    setCoopEtapaFilter,
    setCoopNovoComentario,
    setCoopPlanos,
    setDriverSortMode,
    setEditandoMeta,
    setEditandoMetaEt,
    setEtapaDriversFilter,
    setEtapaHistSel,
    setEtapaSel,
    setEvaChatAtivoId,
    setEvaChats,
    setFiltroCidadeAberto,
    setFiltroResp,
    setFiltroSt,
    setGamificacaoOn,
    setHiddenLines,
    setHistoricoEvaVisivel,
    setMetaEtapa,
    setMetas,
    setMetasCardOpen,
    setMetasEtapas,
    setModal,
    setMostrarOcultos,
    setNotifFeedback,
    setNotifModalFiltro,
    setNotifModalOpen,
    setNotifOpen,
    setNotifs,
    setPB,
    setPD,
    setPE,
    setPJ,
    setPS,
    setPeriodoCustom,
    setPeriodoG,
    setPrefilledAcao,
    setRespDropOpen,
    setSegIndicador,
    setStDropOpen,
    setSucessoFiltroPeriodo,
    setSucessoModalOpen,
    setTab,
    setTipoBenefAberto,
    setTipoBeneficiario,
    setVerbatinsModal,
    stDropOpen,
    sucessoFiltroPeriodo,
    sucessoModalOpen,
    tab,
    tipoBenefAberto,
    tipoBeneficiario,
    todasCidades,
    toggleCidade,
    toggleComentarios,
    toggleCoopDriver,
    toggleCurtida,
    toggleLine,
    toggleSegHist
  } = ctx;
  return (()=>{
        // Build benchmark rows dynamically: 4 consolidados + 11 etapas
        const cesEt  = db.etapas.filter(e=>(JCFG[e.e]&&JCFG[e.e].tipo)==="ces");
        const csatEt = db.etapas.filter(e=>(JCFG[e.e]&&JCFG[e.e].tipo)==="csat");
        const cesGeral  = cesEt.length  ? Math.round(cesEt.reduce((s,e)=>s+e.v,0)/cesEt.length)  : 0;
        const csatGeral = csatEt.length ? Math.round(csatEt.reduce((s,e)=>s+e.v,0)/csatEt.length): 0;
        const cesGeralSys  = cesEt.length  ? Math.round(cesEt.reduce((s,e)=>s+((JCFG[e.e]&&JCFG[e.e].sys)||0),0)/cesEt.length)  : 0;
        const csatGeralSys = csatEt.length ? Math.round(csatEt.reduce((s,e)=>s+((JCFG[e.e]&&JCFG[e.e].sys)||0),0)/csatEt.length): 0;
        // Jornada CX = média de TODAS as 11 etapas (CES + CSAT juntos)
        const jcxGeral    = db.etapas.length ? Math.round(db.etapas.reduce((s,e)=>s+e.v,0)/db.etapas.length) : 0;
        const jcxGeralSys = db.etapas.length ? Math.round(db.etapas.reduce((s,e)=>s+((JCFG[e.e]&&JCFG[e.e].sys)||0),0)/db.etapas.length) : 0;

        // Média da Concorrência Nacional (fora do Sistema Unimed) — dados anonimizados de operadoras não-Unimed
        // Em produção viriam do backend. Aqui, hardcoded com base em benchmarks públicos típicos do setor
        const CONCORRENCIA_NACIONAL = {
          "Jornada CX Geral": 54, "NPS Geral": 38, "CES Geral": 52, "CSAT Geral": 58,
          "Vendas":74, "Boas-Vindas":72, "Agend. Consultas":42, "Consulta":76, "Agend. Exames":48,
          "Exames":70, "Atend. Operadora":31, "Aplicativo":60, "Portal":52, "Promoção da Saúde":62, "Comunicação Op.":58
        };
        const concNacGeral = Math.round((CONCORRENCIA_NACIONAL["Jornada CX Geral"] || 54));

        const rows = [
          {k:"Jornada CX Geral", tipo:"JCX",  vc:jcxGeral,  med:jcxGeralSys,  conc:CONCORRENCIA_NACIONAL["Jornada CX Geral"],  destaque:true},
          {k:"NPS Geral",        tipo:"NPS",  vc:db.nps,    med:SYS_NPS,      conc:CONCORRENCIA_NACIONAL["NPS Geral"],         destaque:true},
          {k:"CES Geral",        tipo:"CES",  vc:cesGeral,  med:cesGeralSys,  conc:CONCORRENCIA_NACIONAL["CES Geral"],         destaque:true},
          {k:"CSAT Geral",       tipo:"CSAT", vc:csatGeral, med:csatGeralSys, conc:CONCORRENCIA_NACIONAL["CSAT Geral"],        destaque:true},
          ...db.etapas.map(e=>{
            const cfg = JCFG[e.e] || {tipo:"csat",sys:60};
            return {k:e.e, tipo:cfg.tipo.toUpperCase(), vc:e.v, med:cfg.sys, conc:CONCORRENCIA_NACIONAL[e.e]||(cfg.sys-8), destaque:false};
          }),
        ];

        // Position vs system (relative)
        function classifyPos(vc, med){
          const d = vc - med;
          if (d >= 10) return {label:"🏆 Top sistema",      color:C.green,  bg:C.greenBg};
          if (d >= 3)  return {label:"↑ Acima da média",    color:C.blue,   bg:C.blueBg};
          if (d > -3)  return {label:"→ Na média",          color:C.orange, bg:C.orangeBg};
          return            {label:"↓ Abaixo da média",   color:C.red,    bg:C.redBg};
        }
        // Absolute classification — uses ESCALA for CES/CSAT/JCX, NPS scale for NPS
        function classifyAbs(tipo, val){
          if (tipo === "NPS") {
            if (val >= 75) return {label:"✦ Excelência",      color:"#059669", bg:"#ECFDF5"};
            if (val >= 50) return {label:"✓ Qualidade",       color:"#16a34a", bg:"#F0FDF4"};
            if (val >= 0)  return {label:"→ Aperfeiçoamento", color:"#d97706", bg:"#FFFBEB"};
            return            {label:"✗ Crítico",          color:"#991b1b", bg:"#FFF1F2"};
          }
          // CES/CSAT/JCX use the same ESCALA as the rest of the dashboard
          const e = ESCALA.find(x=>val>=x.min) || ESCALA[ESCALA.length-1];
          return {label:e.label, color:e.color, bg:e.bg};
        }
        // Variation: pp for percentages, pts for NPS
        function fmtVar(tipo, vc, med){
          const d = vc - med;
          const sign = d > 0 ? "+" : (d < 0 ? "−" : "");
          const abs = Math.abs(d);
          const unit = tipo === "NPS" ? "pts" : "pp";
          const color = d >= 3 ? C.green : (d <= -3 ? C.red : C.orange);
          return {text: `${sign}${abs} ${unit}`, color};
        }

        return <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{fontSize:15,fontWeight:700,color:C.text,letterSpacing:"-0.02em"}}>Benchmarking Sistema Unimed</div>
            <PeriodPill value={pB} onChange={setPB}/>
          </div>
          <Card style={{padding:"14px 18px",background:C.g800,border:"none",display:"flex",alignItems:"center",gap:12}}>
            <Trophy size={22} color={C.g300}/>
            <div>
              <div style={{color:"#FFFFFF",fontWeight:600,fontSize:14}}>Benchmarking Sistema Unimed — {PER[pB].label}</div>
              <div style={{color:"rgba(255,255,255,.45)",fontSize:11}}>Base: {db.bench.base} cooperativas Unimed · dados anonimizados</div>
            </div>
          </Card>
          <Section title="Sua posição vs. Sistema Unimed" pad={false}>
            <div style={{padding:"0 20px 18px",overflowX:"auto"}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                <thead><tr>{[
                  {h:"Indicador",              align:"left"},
                  {h:"Você",                   align:"center"},
                  {h:"Classificação",          align:"center"},
                  {h:"Média Sistema Unimed",   align:"center"},
                  {h:"Concorrência Nacional",  align:"center"},
                  {h:"Variação vs Unimed",     align:"center"},
                  {h:"Posição",                align:"center"},
                ].map(({h,align})=><th key={h} style={{padding:"10px 12px",textAlign:align,background:C.g800,color:h==="Você"?C.g300:h==="Concorrência Nacional"?"#FBBF24":"#FFFFFF",fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.06em",borderBottom:`2px solid ${C.g600}`}}>{h}</th>)}</tr></thead>
                <tbody>{rows.map((row,i)=>{
                  const pos = classifyPos(row.vc,row.med);
                  const abs = classifyAbs(row.tipo,row.vc);
                  const vr  = fmtVar(row.tipo,row.vc,row.med);
                  const vrConc = fmtVar(row.tipo,row.vc,row.conc);
                  const isHl = row.destaque;
                  const tipoColor = row.tipo==="NPS"?C.g700:row.tipo==="CES"?C.blue:row.tipo==="JCX"?"#d97706":C.g600;
                  const tipoBg    = row.tipo==="NPS"?C.g100:row.tipo==="CES"?C.blueBg:row.tipo==="JCX"?"#FFFBEB":C.greenBg;
                  const cellPad = isHl?"14px 12px":"11px 12px";
                  return <tr key={i} style={{
                    background: isHl ? C.g100 : (i%2===0?C.surface:C.surf3),
                    borderBottom:`1px solid ${C.border}`,
                    borderTop: isHl && i===0 ? "none" : (isHl ? `2px solid ${C.g300}` : "none"),
                  }}>
                    <td style={{padding:cellPad,fontWeight:isHl?700:500,color:C.text,fontSize:isHl?14:13}}>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <Tag label={row.tipo} color={tipoColor} bg={tipoBg}/>
                        {row.k}
                      </div>
                    </td>
                    <td style={{padding:cellPad,textAlign:"center",fontWeight:700,fontSize:isHl?20:16,color:tipoColor,letterSpacing:"-0.03em"}}>
                      {row.tipo==="NPS"?row.vc:`${row.vc}%`}
                    </td>
                    <td style={{padding:cellPad,textAlign:"center"}}>
                      <Tag label={abs.label} color={abs.color} bg={abs.bg} size={isHl?"md":"sm"}/>
                    </td>
                    <td style={{padding:cellPad,textAlign:"center",color:C.text3,fontSize:isHl?15:13,fontWeight:isHl?600:400}}>
                      {row.tipo==="NPS"?row.med:`${row.med}%`}
                    </td>
                    <td style={{padding:cellPad,textAlign:"center"}}>
                      <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
                        <div style={{color:"#B45309",fontSize:isHl?15:13,fontWeight:isHl?700:600}}>
                          {row.tipo==="NPS"?row.conc:`${row.conc}%`}
                        </div>
                        <div style={{fontSize:9,fontWeight:700,color:vrConc.color,background:vrConc.color+"15",padding:"1px 6px",borderRadius:20}}>
                          {vrConc.text} vs mercado
                        </div>
                      </div>
                    </td>
                    <td style={{padding:cellPad,textAlign:"center",fontWeight:700,fontSize:isHl?15:13,color:vr.color,letterSpacing:"-0.02em"}}>
                      {vr.text}
                    </td>
                    <td style={{padding:cellPad,textAlign:"center"}}>
                      <Tag label={pos.label} color={pos.color} bg={pos.bg} size={isHl?"md":"sm"}/>
                    </td>
                  </tr>;
                })}</tbody>
              </table>
            </div>
          </Section>
        </div>;
      })();
}
